export const CLIENT_LIBRARY_URL = "https://nucleusfinancial.com/wrap/no-adviser";
export const GO_SUPPORT_URL =
    "https://www.nucleusfinancial.com/client-home/nucleus-go-client-support";
export const TERMS_AND_CONDITIONS_URL = "https://nucleusfinancial.com/terms-use";
export const PRIVACY_POLICY_URL = "https://nucleusfinancial.com/privacy-notice";
export const GO_WEB_LOGIN_URL = "https://go.nucleusfinancial.com";
export const LIVE_CHAT_URL = "https://go.nucleusfinancial.com/chat/livechat.html";
